<script setup lang="ts">
import { computed } from 'vue'
import Icon from './Icon.vue'
import ScrollAnimate from './ScrollAnimate.vue'
import { useI18n } from '../composables/useI18n'

interface PainPoint {
  icon: string
  title: string
  subtitle: string
  description: string
}

const { t } = useI18n()

const painPoints = computed<PainPoint[]>(() => t('painPoints.items') as PainPoint[])
</script>

<template>
  <section id="pain-points" class="py-20 bg-base-100">
    <div class="max-w-6xl mx-auto px-4">
      <ScrollAnimate as="div" class="text-center max-w-3xl mx-auto mb-12">
        <h2 class="text-3xl md:text-4xl font-bold text-base-content">{{ t('painPoints.title') }}</h2>
        <p class="text-lg text-base-content/70 mt-4">
          {{ t('painPoints.subtitle') }}
        </p>
      </ScrollAnimate>

      <div class="grid md:grid-cols-3 gap-6">
        <ScrollAnimate
          v-for="(point, index) in painPoints"
          :key="point.title"
          as="div"
          class="card bg-base-200 border border-base-300 border-l-4 border-l-primary hover:border-primary/40 transition-colors"
          :delay="index * 0.1"
        >
          <div class="card-body">
            <div class="flex items-start gap-4">
              <div
                class="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary shrink-0"
              >
                <Icon :name="point.icon" iconClass="w-6 h-6" />
              </div>
              <div>
                <h3 class="card-title text-xl leading-tight">{{ point.title }}</h3>
                <p class="text-sm text-primary font-medium mb-2">{{ point.subtitle }}</p>
                <p class="text-base-content/70 text-sm">{{ point.description }}</p>
              </div>
            </div>
          </div>
        </ScrollAnimate>
      </div>
    </div>
  </section>
</template>
